/**
 * Mapping từ tabKey (route param) sang SubSystemCode (để check permission)
 * Dùng cho dynamic tab init permission check
 * 
 * Format:
 * - Key: tabKey trong route params (lowercase)
 * - Value: SubSystemCode để check permission
 * 
 * Example:
 * - User click tab "Phiếu thu" → tabKey = "careceipt"
 * - Mapping: "careceipt" → "CAReceipt"
 * - Check permission: Permission["CAReceipt"]
 */
export default {
  // ===== TIỀN MẶT =====
  careceipt: 'CAReceipt', // Phiếu thu
  capayment: 'CAPayment', // Phiếu chi
  cafundinventory: 'CAFundInventory', // Kiểm kê quỹ
  
  // ===== TIỀN GỬI NGÂN HÀNG =====
  cheque: 'ChequeIssuance', // Phát hành séc
  deposit: 'AccountDeposit', // Nộp tiền vào tài khoản
  
  // ===== TÀI SẢN - TANG VẬT =====
  inwardstock: 'InventoryInInward', // Phiếu nhập kho
  outwardstock: 'InventoryInOutward', // Phiếu xuất kho
  assettransfer: 'InTransfer', // Chuyển kho
  inventory: 'InventoryCount', // Kiểm kê
  
  // ===== SỔ CÁI =====
  assetevaluation: 'CashAndAssetDetermination', // Xác định tiền, tài sản
  generaljournalentry: 'OtherTransactionVoucher', // Chứng từ nghiệp vụ khác
  accounttransferslip: 'AccountClosingVoucher', // Kết chuyển
  submitreport: 'ReportGeneration', // Nộp cấp trên / Lập báo cáo
  
  // ===== SỐ DƯ BAN ĐẦU ===== (Tất cả các tab đều dùng chung 1 SubSystemCode: OpeningBalanceEntry)
  accountbalancetab: 'OpeningBalanceEntry', // Số dư tài khoản
  bankaccountbalancetab: 'OpeningBalanceEntry', // Số dư tài khoản ngân hàng
  objectaccountbalancetab: 'OpeningBalanceEntry', // Số dư theo đối tượng
  objectanddecisionaccountbalancetab: 'OpeningBalanceEntry', // Số dư theo đối tượng và quyết định
  otheraccountbalancetab: 'OpeningBalanceEntry', // Số dư tài khoản khác
  assetaccountbalancetab: 'OpeningBalanceEntry', // Số dư tài sản tang vật
  
  // ===== NGÂN HÀNG =====
  badeposit: 'BADeposit', // Thu tiền gửi
  bawithdraw: 'BAWithdraw', // Chi tiền gửi
  bafundinventory: 'BAFundInventory', // Kiểm kê tiền gửi
  
  // ===== MUA HÀNG =====
  puinvoice: 'PUInvoice', // Hóa đơn mua hàng
  puvoucherpurchase: 'PUVoucherPurchase', // Mua hàng
  
  // ===== BÁN HÀNG =====
  sainvoice: 'SAInvoice', // Hóa đơn bán hàng
  savouchersale: 'SAVoucherSale', // Bán hàng
  
  // ===== KHO =====
  ininward: 'INInward', // Nhập kho
  inoutward: 'INOutward', // Xuất kho
  intransfer: 'INTransfer', // Điều chuyển
  
  // ===== TÀI SẢN CỐ ĐỊNH =====
  faincrement: 'FAIncrement', // Ghi tăng TSCĐ
  fadecrement: 'FADecrement', // Ghi giảm TSCĐ
  fadepreciation: 'FADepreciation', // Khấu hao TSCĐ
  
  // ===== CÔNG CỤ DỤNG CỤ =====
  suincrement: 'SUIncrement', // Ghi tăng CCDC
  sudecrement: 'SUDecrement', // Ghi giảm CCDC
  suallocate: 'SUAllocate', // Phân bổ CCDC
  
  // ===== LƯƠNG =====
  pasalary: 'PASalary', // Bảng lương
  papersonalincometax: 'PAPersonalIncomeTax', // Thuế TNCN
  
  // ===== TỔNG HỢP =====
  glvoucher: 'GLVoucher', // Chứng từ nghiệp vụ khác
  glprofitlosstransfer: 'GLProfitLossTransfer', // Xác định kết quả
  
  // ===== BÁO CÁO =====
  report: 'Report', // Báo cáo
  
  // ===== PROCESS =====
  process: 'Process', // Quy trình
};
